import React from 'react'

export const TooltipPropsContext = React.createContext(undefined)
export const TooltipHandlersContext = React.createContext(undefined)
